"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreDetailsResponseMapper = void 0;
var StoreDetailsResponseMapper = /** @class */ (function () {
    function StoreDetailsResponseMapper(data) {
        this.localData = data;
    }
    StoreDetailsResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return StoreDetailsResponseMapper;
}());
exports.StoreDetailsResponseMapper = StoreDetailsResponseMapper;
//# sourceMappingURL=StoreDetailsResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/StoreDetailsResponseMapper.js
// module id = 2084
// module chunks = 8